import React from 'react';
import { connect } from 'react-redux';
import URI from 'urijs';

// components
import BrokerageCard from '../../partials/brokerage-card/brokerage-card';

// modules
import styles from '../Containers.module.scss';

function OfficeSearchResult({ record, searchURI }) {
  return (
    <BrokerageCard data={record} className={styles.searchResult} searchURI={searchURI} />
  );
}

export default connect((state, props) => {
  const { pathname, search = {} } = state.routing.location;
  return {
    searchURI: pathname && URI(pathname).search(search).toString()
  };
}, {})(OfficeSearchResult);



// WEBPACK FOOTER //
// ./src/containers/OfficeSearch/OfficeSearchResult.js